import React from 'react';
import { SH3 } from './styles';

const H3 = ({
    children,
    titleUnderline,
}) => {
    return (
        <SH3 titleUnderline={titleUnderline} >
            <span>
                { children }
            </span>
        </SH3>
    );
};

export default H3;
